function normalizedBase(value: string): string {
  const trimmed = value.trim();
  if (!trimmed || trimmed === '/') return '';
  return '/' + trimmed.replace(/^\/+|\/+$/g, '');
}

// Vite replaces BASE_URL at build time. Keeping one canonical base here ensures
// navigation, auth, and API requests move together when the console is mounted
// below an existing TLS host (for example /gtm-console/).
export const CONSOLE_BASE_PATH = normalizedBase(import.meta.env.BASE_URL || '/');

export function withConsoleBase(path: string): string {
  const normalized = path.startsWith('/') ? path : '/' + path;
  return CONSOLE_BASE_PATH + normalized;
}

export function withoutConsoleBase(pathname: string): string {
  if (!CONSOLE_BASE_PATH) return pathname;
  if (pathname === CONSOLE_BASE_PATH) return '/';
  if (pathname.startsWith(CONSOLE_BASE_PATH + '/')) {
    return pathname.slice(CONSOLE_BASE_PATH.length) || '/';
  }
  return '/';
}
